import * as React from "react";
import { connect } from "react-redux";

import ChemistInvoice from "../../screens/Chemist/ChemistInvoice/index";
import {
  ChemistInvoiceList,
  ChemistInvoiceSelectedPage,
  ChemistInvoiceStatusChange,
} from "./action";
class ChemistInvoiceContainer extends React.Component<Props, State> {
  render() {
    return (
      <ChemistInvoice
        chemistInvoiceList={this.props.ChemistInvoiceList}
        chemistInvoiceDtlsList={this.props.chemistInvoiceDtlsList}
        chemistInvoiceDtlsCount={this.props.chemistInvoiceDtlsCount}
        ChemistInvoiceSelectedPage={this.props.ChemistInvoiceSelectedPage}
        statusChange={this.props.ChemistInvoiceStatusChange}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    ChemistInvoiceList: (value) => {
      dispatch(ChemistInvoiceList(value));
    },
    ChemistInvoiceSelectedPage: value => {
      dispatch(ChemistInvoiceSelectedPage(value));
    },
    ChemistInvoiceStatusChange: value => {
      dispatch(ChemistInvoiceStatusChange(value));
    },
  };
}
function mapStateToProps(state) {
  return {
    chemistInvoiceDtlsList: state.ChemistInvoiceReducer.chemistInvoiceDtlsList,
    chemistInvoiceDtlsCount: state.ChemistInvoiceReducer.chemistInvoiceDtlsCount,
  };
};

export default connect(
  mapStateToProps,
  bindAction
)(ChemistInvoiceContainer);